import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { inject } from '@angular/core';

export const guardsClientGuard: CanActivateFn = (route, state): boolean => {
  try {
    const token = localStorage.getItem('token');

    if (!token) throw new Error("Usuario sem token de autenticacao");

    return true;
  } catch (error: any) {
    return false;
  }


};


